const TRUSTED_QR_ORIGIN = 'https://qr.airkop.com';

export const resolveUnitQrEnvironment = (apiBaseUrl = '') => {
  const normalized = String(apiBaseUrl || '').toLowerCase();
  if (normalized.includes('backend-dev')) return 'development';
  if (normalized.includes('staging')) return 'staging';
  return 'production';
};

export const buildUnitOutletQrCodes = ({ requestedDeviceId, backendData, apiBaseUrl }) => {
  const requested = String(requestedDeviceId || '').trim();
  const confirmed = String(backendData?.deviceId || '').trim();

  if (!requested || !confirmed || requested !== confirmed) {
    throw new Error('UNIT_QR_DEVICE_MISMATCH');
  }

  const baseUrl = `${TRUSTED_QR_ORIGIN}/qrcode/atmwater/${encodeURIComponent(confirmed)}`;
  return {
    deviceId: confirmed,
    deviceName: backendData?.deviceName || '',
    location: backendData?.location || '',
    environment: resolveUnitQrEnvironment(apiBaseUrl),
    mineral: { outletNo: 1, url: `${baseUrl}-1` },
    pure: { outletNo: 2, url: `${baseUrl}-2` }
  };
};

